import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';

import { Observable, throwError, catchError } from 'rxjs';

import { NotificationLevel, NotificationsService } from '@eiq/notifications';

import { MonitoringService } from '@empathy/global/utils';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private dialog = inject(MatDialog);
  private monitoringService = inject(MonitoringService);
  private not = inject(NotificationsService);
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err) {
          switch (err.status) {
            case 400:
              this.monitoringService.logException(err);
              this.showToast('There was an error completing your request. Please contact the support team');
              break;
            case 401:
              this.dialog.closeAll();
              this.router.navigate(['sign-in'], { replaceUrl: true });
              break;
            case 403:
              this.dialog.closeAll();
              this.router.navigate(['access-forbidden'], { replaceUrl: true });
              break;
            case 429:
              this.showToast('You need to slow down. Try again in a minute.');
              break;
            case 500:
              this.monitoringService.logException(err);
              this.showToast('There was an error completing your request. Please contact the support team');
              break;
            case 0:
            case 503:
              this.showToast('No internet connection');
              break;
            default:
              break;
          }
        }
        return throwError(() => err);
      })
    );
  }

  private showToast(toastMessage: string): void {
    this.not.open({ level: NotificationLevel.Error, title: 'Error', message: toastMessage });
  }
}
